import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'

// Actions
import { getPartner } from '../../../actions/workProvider'
import { getAgreementConstraints } from '../../../actions/agreementConstraint'

import { getBrands } from '../../../actions/common'

// import components
import Header from '../../../shared/components/Header'
// import LeftMenu from '../../../shared/components/Menus/LeftMenu'
import LeftMenuContent from '../../../shared/components/Menus/LeftMenu/Content'

// Elements
// import Text from '../../../shared/elements/text'
// import Check from '../../../shared/elements/check'
import Button from '../../../shared/elements/button'
import SideMenu from '../../../shared/elements/sideMenu'
import SideMenuItem from '../../../shared/elements/sideMenuItem'
import SideMenuCustomItem from '../../../shared/elements/sideMenuCustomItem'
import CloseButton from '../../../shared/elements/closeButton'

// Views
import View from './View'

// import styles
import './constraints.scss'

// Utils
import { hasSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

class Constraints extends Component {
  constructor (props) {
    super(props)
    this.state = {
      price: {},
      view: 'list',
      activeItem: {},
      constraints: [],
      partnerName: '',
      isUpdating: false,
      search: '',
      includeInactive: false
    }
    this.headerButtonsRight = this.headerButtonsRight.bind(this)
    this.onSave = this.onSave.bind(this)
    this.onViewFail = this.onViewFail.bind(this)
    this.setState = this.setState.bind(this)
    this.onShouldUpdate = this.onShouldUpdate.bind(this)
    this.searchList = this.searchList.bind(this)
    this.filterList = this.filterList.bind(this)
  }

  componentDidMount () {
    this.getPartner(this.props)
    this.getAgreementConstraints()
    this.props.getBrands()
    if (typeof this.props.params.ConstraintID !== 'undefined') {
      this.setState({
        view: 'item',
        activeItem: {
          AgreementConstraintId: this.props.params.ConstraintID
        }
      }, () => {
        // console.log('didmount', this.state)
      })
    }
  }

  getPartner (props) {
    if (typeof props.params.partnerID !== 'undefined') {
      props.getPartner(props.params.partnerID).then((res) => {
        this.setState({
          partnerName: res.data.Name
        }, () => {
        })
      }, (err) => {
        if (err.response.status === 401) {
          this.props.router.replace('/orders')
        }
      })
    }
  }

  onShouldUpdate () {
    this.setState({
      view: 'list',
      activeItem: {}
    }, () => {
      this.props.params.ConstraintID = undefined
      this.props.router.push('/partners/' + this.props.params.partnerID + '/constraints')
      this.getAgreementConstraints().then(() => {
        // Toastr
        // window.toastr.success(translation('13444'), translation('13424'))
      }, () => {
        // Toastr
        window.toastr.error(translation('2018'), translation('216'))
      })
    })
  }
  getAgreementConstraints () {
    return this.props.getAgreementConstraints(this.props.params.partnerID).then((res) => {
      this.setState({
        constraints: res.data
      })
      if (res.data.length === 0) {
        this.changeView('create')
      }
    }, () => {
      console.log('err')
    })
  }

  changeView (view) {
    let activeItem = this.state.activeItem
    if (view === 'create') {
      activeItem = {}
    }
    this.setState({
      view: view,
      activeItem: activeItem
    }, () => {
      this.props.router.replace('/partners/' + this.props.params.partnerID + '/constraints')
    })
  }

  headerButtonsRight () {
    if (this.state.view === 'create') return null
    if (!hasSubscriptionPermission(this.props.auth, 10, 0) && this.state.constraints.length < 2) return null

    return (
      <div>
        <Button size='m' spacing={0} labelText={translation(1797)} ariaText={translation('12291')} onClick={this.changeView.bind(this, 'create')} />
      </div>
    )
  }

  searchList (e) {
    if (e.target.name === 'SearchText') {
      this.setState({
        search: e.target.value
      })
    }
    if (e.target.name === 'Inactive') {
      this.setState({
        includeInactive: e.target.checked
      })
    }
  }

  filterList (key) {
    if (key.Name === undefined || key.Name === null) return true
    if (key.Name.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 && (!this.state.includeInactive ? key.Active : true)) {
      return true
    }
    return false
  }

  leftMenu () {
    // If view is create
    if (this.state.view === 'create') {
      const onAdd = () => {
        this.setState({ isUpdating: true })
        this.refs.view.getWrappedInstance().addConstraint().then(() => {
          this.setState({ isUpdating: false })
        }, () => {
          window.toastr.error(translation('12285'), translation('216'))
          this.setState({ isUpdating: false })
        })
      }
      return [
        <SideMenuCustomItem key='0' isFixed>
          <Button disabled={this.state.isUpdating} onClick={onAdd} labelText={translation('1208')} />
        </SideMenuCustomItem>,
        <SideMenuCustomItem key='1' isFixed>
          <Button style='secondary' disabled={this.state.isUpdating} onClick={this.changeView.bind(this, 'list')} labelText={translation('570')} />
        </SideMenuCustomItem>
      ]
    }

    let constraints = this.state.constraints
    let grouping = []
    for (let i = 0; i < constraints.length; i++) {
      let group = grouping.find((val, idx) => { return val.customerGroupName === constraints[i].CustomerGroupName })
      if (group === undefined) {
        group = {
          customerGroupName: constraints[i].CustomerGroupName,
          constraints: []
        }
        grouping.push(group)
      }
      group.constraints.push(constraints[i])
    }

    const renderGroup = (group, key) => {
      const renderItem = (val, key) => {
        // Classname
        // let classNameList = ''
        let isSelected = false
        if (isEqual(val, this.state.activeItem) || parseInt(val.AgreementConstraintId) === parseInt(this.state.activeItem.AgreementConstraintId)) {
          // classNameList = 'active'
          isSelected = true
        }
        // On select
        const selectItem = () => {
          this.setState({
            view: 'item',
            activeItem: val
          }, () => {
            this.props.router.replace('/partners/' + this.props.params.partnerID + '/constraints/' + this.state.activeItem.AgreementConstraintId)
          })
        }
        let name = val.Name
        if (val.Brand !== undefined && val.Brand !== null) {
          name += ' (' + val.Brand + ')'
        }
        // Return
        // let classname = 'item'
        // if (!val.Active) classNameList += ' inactive'

        return (
          <SideMenuItem
            label={name}
            onClick={selectItem}
            selected={isSelected}
            inactive={!val.Active}
            key={key}
          />
        )
        // return (
        //   <LeftMenuItem key={val.AgreementConstraintId} className={classname}>
        //     <span onClick={selectItem} className={classNameList}>{name}</span>
        //   </LeftMenuItem>
        // )
      }

      let groupName = group.customerGroupName
      if (groupName === null) groupName = '(' + translation('12268') + ')'

      return (
        <SideMenuItem
          label={groupName}
          isTitle
          key={key}
        >
          {group.constraints.map(renderItem)}
        </SideMenuItem>
      )
      // return (
      //   <li key={'group_' + key}>
      //     <div className='headeritem'>{groupName}</div>
      //     {group.constraints.filter(this.filterList).map(renderItem)}
      //   </li>
      // )
    }

    // Return
    return grouping.map(renderGroup)
    // return (
    //   <div>
    //     <div className='list__search'>
    //       <Text name='SearchText' onChange={this.searchList} value={this.state.search} />
    //       <Check id='Inactive' name='Inactive' value='0' onChange={this.searchList} checked={this.state.includeInactive === true} labelText={translation('1859')} />
    //     </div>
    //     <ul>
    //       {grouping.map(renderGroup)}
    //     </ul>
    //   </div>
    // )
  }

  onSave (data, type) {
    // console.log('Contacts onSave ', data, type)
    let constraints = [...this.state.constraints]
    if (type === 'create') {
      constraints.push({
        Name: data.Name,
        AgreementConstraintId: data.AgreementConstraintId
      })
      type = 'list'
    } else {
      constraints.map((val, key) => {
        if (val.AgreementConstraintId === data.AgreementConstraintId) {
          val.Name = data.Name
        }
      })
      type = 'item'
    }
    this.setState({
      activeItem: data,
      constraints: constraints,
      view: data.AgreementConstraintId > 0 ? 'item' : 'list'
    }, () => {
      if (data.AgreementConstraintId > 0 && type === 'list') {
        this.getAgreementConstraints()
        this.props.router.params['ConstraintID'] = data.AgreementConstraintId
        this.props.router.replace('/partners/' + this.props.params.partnerID + '/constraints/' + data.AgreementConstraintId)
      }
    })
    // Toastr
    // window.toastr.success(translation('12286'), translation('13424'))
  }

  onViewFail () {
    this.setState({
      view: 'list',
      activeItem: {}
    })
    this.props.router.replace('/partners/' + this.props.params.partnerID + '/constraints')
  }

  renderView () {
    switch (this.state.view) {
      case 'list':
        return <div />
      case 'create':
      case 'item':
        return <View ref='view' item={this.state.activeItem} getAgreementConstraints={this.getAgreementConstraints.bind(this)} onSave={this.onSave} partnerID={this.props.params.partnerID} onShouldUpdate={this.onShouldUpdate.bind(this)} onError={this.onViewFail} />
    }
  }

  changeType (e) {
    let value = parseInt(e.target.value)
    this.setState({
      price: {
        [e.target.name]: value
      }
    })
  }

  render () {
    let headerButtonsGoBack
    headerButtonsGoBack = (router, t) => {
      const goBack = () => {
        this.props.router.push({
          pathname: '/partners/' + this.props.router.params.partnerID
        })
      }
      return (
        <CloseButton key='back_close' ariaText={t('2060')} onClick={goBack} />
      )
    }

    return (
      <div className='constraints__screen'>
        <Header router={this.props.router} title={translation('12292') + ' - ' + this.state.partnerName} renderRight={this.headerButtonsRight} icon={'menu/Customers-White.png'} showBack headerButtonsGoBack={headerButtonsGoBack} />

        <SideMenu showFilter={this.state.view !== 'create'} hideInactiveCheck={this.state.view === 'create'}>
          {this.leftMenu()}
        </SideMenu>

        <LeftMenuContent className='constraints__screen--inner'>
          {this.renderView()}
        </LeftMenuContent>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    activeItem: state.activeItem
  }
}

export default connect(mapStateToProps, { getAgreementConstraints, getPartner, getBrands })(Constraints)



// WEBPACK FOOTER //
// ./src/app/pages/Partners/Constraints/index.js